/**
 * `properties.verification` (M108): what an edit does to a verified property. One so far:
 *
 *   reverify_prompt   a save that changes a verified property (verified_at set on the locked
 *                     row) asks whether to keep it verified or clear the verification
 *                     (API services/save-with-source answers `reverify_prompt` with the save,
 *                     read in its transaction, settingSql). Never clears it by itself: off,
 *                     the save says nothing about verification.
 *
 * Who: editPermission feature:settings_reference_data (the data-curation settings gate, as
 * `ingestion`; admins always pass). No readPermission: the save answers the value with its data.
 * Edited on Settings → App settings. Default on (M108, Noah: prompt, never clear silently).
 */
import { z } from 'zod';
import { defineGroup } from '../define.js';
export const propertiesVerification = defineGroup('properties.verification', {
    label: 'Property verification',
    editPermission: 'feature:settings_reference_data',
    settings: {
        reverify_prompt: {
            type: z.boolean(),
            default: true,
            label: 'Ask to re-check after editing a verified property',
            help: 'When someone saves a change to a verified property, ask whether to keep it verified or clear the verification. Off: the save leaves verification alone and says nothing.',
        },
    },
});
//# sourceMappingURL=properties.js.map